/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import {
  Form, message, Input, Row, Col, Modal, DatePicker, Select, Divider,
} from 'antd'

import moment from 'moment'

import { fetch } from '../../../utils/fetch'

import AuthenQueueModal from './AuthenQueueModal'

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
}

const CheckQueueModal = ({
  checkQueueData, visible, onCancel, onSuccess, orderId,
}) => {
  const [verify, setVerify] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [authenModal, setAuthenModal] = useState(false)
  const [orderShipto, setOrderShipto] = useState('')

  const { Option } = Select
  const [form] = Form.useForm()

  const disabledDate = (current) => current < moment(new Date()).add(19, 'days')
  const numberWithCommas = (price) => {
    if (!Number.isNaN(price)) return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return '-'
  }

  const checkQueueHomag = (values) => {
    const amount = Number.parseFloat(values.amount?.replace(',', ''))
    const startTime = values?.delvTime
    const delvDate = moment(values?.delvDate).format('YYYY.MM.DD')
    setIsLoading(true)
    fetch({
      url: `/order/${orderId}/queue/check`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: {
        amount,
        delivery_date: delvDate,
        start_time: startTime,
        booking_site: '1101',
        shipTo: orderShipto,
      },
    }).then((res) => {
      // console.log(res.data)
      if (res.data?.success) {
        setIsLoading(false)
        onSuccess(values)
      } else {
        setTimeout(() => {
          setIsLoading(false)
          message.error(<>Quota is not available</>)
        }, 600)
      }
    })
    setVerify(false)
  }

  const calcPrice = () => {
    const sumPrice = checkQueueData
      .reduce((prev, curr) => prev + (Number(curr.itemUnitPrice) * Number(curr.itemQty)), 0)
    const calculatedPrice = numberWithCommas(String(Number(sumPrice).toFixed(2)))
    form.setFieldsValue({
      amount: calculatedPrice,
    })
  }

  const checkSelectedDate = (values) => {
    if (values.delvDate <= moment(new Date()).add(23, 'days') && verify === false) {
      setAuthenModal(true)
    } else if (values.delvDate <= moment(new Date()).add(23, 'days') && verify) {
      checkQueueHomag(values)
    } else if (values.delvDate >= moment(new Date()).add(23, 'days')) {
      checkQueueHomag(values)
    }
  }

  const getHeaderData = async () => {
    await fetch({
      url: `/order/${orderId}/header`,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res?.data?.success) {
        const headerData = res.data.data
        // console.log(`Header : ${JSON.stringify(headerData)}`)
        setOrderShipto(headerData.shipTo)
      } else {
        console.log('Error:', res.data)
        message.error(res?.data?.message)
      }
      setIsLoading(false)
    })
  }

  useEffect(() => {
    if (visible) {
      getHeaderData()
      setVerify(false)
      calcPrice(checkQueueData)
      form.setFieldsValue({
        delvDate: moment(new Date()).add(24, 'days'),
        delvTime: '2',
      })
    }
  }, [visible])

  return (
    <>
      <Modal
        title="Check Queue"
        okText="Check Queue"
        cancelText="Cancel"
        visible={visible}
        maskClosable={false}
        onCancel={onCancel}
        confirmLoading={isLoading}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              checkSelectedDate(values)
            })
            .catch((info) => {
              message.error(info)
            })
        }}
      >
        <Form
          {...layout}
          form={form}
          preserve={false}
          name="check_queue"
          layout="horizontal"
        >
          <Row gutter={[16, 16]}>
            <Col className="gutter-row" span={24}>
              <Form.Item name="delvDate" label="Delv Date">
                <DatePicker
                  format="DD/MM/YYYY"
                  disabledDate={disabledDate}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={24}>
              <Form.Item name="delvTime" label="Delv Time">
                <Select>
                  <Option value="2">10:00</Option>
                  <Option value="4">13:00</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={24}>
              <Form.Item name="amount" label="Amount">
                <Input disabled suffix={<><Divider type="vertical" />THB</>} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <AuthenQueueModal
        orderId={orderId}
        visible={authenModal}
        onCancel={() => { setAuthenModal(false) }}
        verify={(values) => {
          if (values) {
            setAuthenModal(false)
            setVerify(values)
          } else {
            setVerify(false)
          }
        }}
      />
    </>
  )
}

export default CheckQueueModal

